module.exports = __webpack_public_path__ + "static/media/Manufacturing.a0a82561.svg";